import * as types from './types';

const initialState = {
  OvernightCampBranchDetails: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case types.OVERNIGHT_CAMP_BRANCH_DETAILS_SUCCESS: {
      return {
        ...state,
        OvernightCampBranchDetails: action.payload
      };
    }
    case types.OVERNIGHT_CAMP_BRANCH_DETAILS_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
